import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UsersTable } from './components/UsersTable';
import { UserDetail } from './pages/UserDetail';
import { ProposalDetail } from './pages/ProposalDetail';
import { Banner } from './components/Banner';
import { Sidebar } from './components/Sidebar';
import { Proposals } from './pages/Proposals';
import { ComingSoon } from './pages/ComingSoon';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-background flex flex-col" data-id="element-1">
        <Banner data-id="element-2" />
        <div className="flex-1 flex" data-id="element-3">
          <Sidebar data-id="element-4" />
          <div className="flex-1" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<div className="p-6" data-id="element-8">
                    <div className="max-w-6xl mx-auto" data-id="element-9">
                      <h1 className="text-2xl font-bold mb-6" data-id="element-10">
                        Users Management
                      </h1>
                      <UsersTable data-id="element-11" />
                    </div>
                  </div>} data-id="element-7" />
              <Route path="/users/:userId" element={<UserDetail data-id="element-13" />} data-id="element-12" />
              <Route path="/users/:userId/proposals/:proposalId" element={<ProposalDetail data-id="element-15" />} data-id="element-14" />
              <Route path="/proposals" element={<Proposals data-id="element-17" />} data-id="element-16" />
              <Route path="/dashboard" element={<ComingSoon title="Dashboard" data-id="element-19" />} data-id="element-18" />
              <Route path="/financing" element={<ComingSoon title="Financing" data-id="element-21" />} data-id="element-20" />
              <Route path="/electricity" element={<ComingSoon title="Electricity" data-id="element-23" />} data-id="element-22" />
              <Route path="/products" element={<ComingSoon title="Products" data-id="element-25" />} data-id="element-24" />
              <Route path="*" element={<Navigate to="/" replace data-id="element-27" />} data-id="element-26" />
            </Routes>
          </div>
        </div>
      </div>
    </BrowserRouter>;
}